import axios from "axios";
import { serverApi } from "../../../config/Keys";
import {
  CLEAR_ERRORS,
  CLEAR_LOADER,
  SET_LOADER,
  SET_LOADER_SECONDARY,
  SET_UOM_MANAGEMENT,
  SET_UOM_RATIO,
  SET_UOM_RATIOTWO,
  SET_RATIO_CONVERSATION,
} from "../../types";
import { setErrors } from "../errorActions";
import Alert from "react-s-alert";

/*************************************************
 * @DESC ADD ACTION FOR UOM & RATIO MANAGEMENT
 ************************************************/
export const admin_add_uom =
  (token, formData, onSuccess) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER_SECONDARY });
      let response = await axios.post(`${serverApi}/uom`, formData, {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 201) {
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      Alert.error(
        `<h4>${err?.response?.message || "Please enter correct details."}</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        }
      );
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_add_uom_ratio =
  (token, formData, onSuccess) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER_SECONDARY });
      let response = await axios.post(`${serverApi}/uom-ratio`, formData, {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 201) {
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      Alert.error(
        `<h4>${err?.response?.message || "Please enter correct details."}</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        }
      );
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*************************************************
 * @DESC GET ACTION FOR UOM & RATIO MANAGEMENT
 ************************************************/
export const admin_get_all_uom =
  (
    token,
    currentPageNo,
    nextPageNo,
    actionPerform,
    dateQuery,
    onSuccess,
    status,
    classification,
    system,
    statusfilter,
    classificationFilter,
    systemFilter
  ) =>
  async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });
      let response = await axios.get(
        `${serverApi}/uom?page=${currentPageNo}&limit=${nextPageNo}${
          actionPerform
            ? ""
            : `&startDate=${dateQuery?.startDate}&endDate=${
                dateQuery?.endDate
              }${status ? `&filterBY1=${statusfilter}` : ""}${
                classification ? `&filterBY2=${classificationFilter}` : ""
              }${system ? `&filterBY3=${systemFilter}` : ""}`
        }`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        dispatch({ type: SET_UOM_MANAGEMENT, payload: response.data });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      Alert.error(
        `<h4>${
          err?.response?.data?.message ||
          err?.response?.data ||
          err?.response?.message ||
          "Please enter correct details."
        }</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        }
      );
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_get_uom_filter_search =
  (
    token,
    currentPageNo,
    nextPageNo,
    currentStatus,
    onSuccess,
    currentUomStatus,
    currentUomClassification,
    currentUomSystem
  ) =>
  async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      let response = await axios.get(
        `${serverApi}/uom?page=${currentPageNo}&limit=${nextPageNo}${
          currentStatus
            ? `&filterBY1=${currentUomStatus}&filterBY2=${currentUomClassification}&filterBY3=${currentUomSystem}`
            : ""
        }`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        dispatch({ type: SET_UOM_MANAGEMENT, payload: response.data });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      Alert.error(
        `<h4>${
          err?.response?.data?.message ||
          err?.response?.data ||
          err?.response?.message ||
          "Please enter correct details."
        }</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        }
      );
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_get_all_uom_ratio =
  (
    token,
    currentPageNo,
    nextPageNo,
    actionPerform,
    dateQuery,
    onSuccess,
    status,
    classification,
    statusfilter,
    classificationFilter
  ) =>
  async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });
      let response = await axios.get(
        `${serverApi}/uom-ratio?page=${currentPageNo}&llimit=${nextPageNo}${
          actionPerform
            ? ""
            : `&startDate=${dateQuery?.startDate}&endDate=${
                dateQuery?.endDate
              }${status ? `&filterBY1=${statusfilter}` : ""}${
                classification ? `&filterBY2=${classificationFilter}` : ""
              }`
        }`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        dispatch({ type: SET_UOM_RATIO, payload: response.data });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      Alert.error(`<h4>${err?.response?.message}</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 5000,
        offset: 35,
      });
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_uom_ratio_filter_search =
  (
    token,
    currentPageNo,
    nextPageNo,
    currentStatus,
    onSuccess,
    currentRatioStatus,
    currentRatioClassification,
    fromshortCode
  ) =>
  async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      let response = await axios.get(
        `${serverApi}/uom-ratio?page=${currentPageNo}&llimit=${nextPageNo}${
          currentStatus
            ? `&filterBY1=${currentRatioStatus}&filterBY2=${currentRatioClassification}&filterBY3=${fromshortCode}`
            : ""
        }`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        dispatch({ type: SET_UOM_RATIO, payload: response.data });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      Alert.error(`<h4>${err?.response?.message}</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 5000,
        offset: 35,
      });
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_uom_ratio_filter_searchTwo =
  (
    token,
    currentPageNo,
    nextPageNo,
    currentStatus,
    onSuccess,
    currentRatioStatus,
    currentRatioClassification,
    fromshortCode
  ) =>
  async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      let response = await axios.get(
        `${serverApi}/uom-ratio?page=${currentPageNo}&llimit=${nextPageNo}${
          currentStatus
            ? `&filterBY1=${currentRatioStatus}&filterBY2=${currentRatioClassification}&filterBY3=${fromshortCode}`
            : ""
        }`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        dispatch({ type: SET_UOM_RATIOTWO, payload: response.data });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      Alert.error(`<h4>${err?.response?.message}</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 5000,
        offset: 35,
      });
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_get_all_ratio_conversation =
  (token, uomType, currentStatus) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER_SECONDARY });
      let response = await axios.get(
        `${serverApi}/uom?type=${uomType}&major_classification=${currentStatus}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        dispatch({ type: SET_RATIO_CONVERSATION, payload: response.data });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      Alert.error(
        `<h4>${err?.response?.data || "Please enter correct details."}</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        }
      );
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*************************************************
 * @DESC EDIT ACTION FOR UOM & RATIO MANAGEMENT
 ************************************************/
export const admin_update_uom =
  (token, formData, uom_id, onEditSuccess) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER_SECONDARY });
      let response = await axios.patch(`${serverApi}/uom/${uom_id}`, formData, {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        onEditSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_update_uom_ratio =
  (token, formData, ratio_id, onEditSuccess) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER_SECONDARY });
      let response = await axios.patch(
        `${serverApi}/uom-ratio/${ratio_id}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        onEditSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      console.log(err.response);
      Alert.error(
        `<h4>${
          err?.response?.data?.message ||
          err?.response?.data ||
          "Please enter correct details."
        }</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        }
      );
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*************************************************
 * @DESC DELETE ACTION FOR UOM & RATIO MANAGEMENT
 ************************************************/
export const admin_delete_uom =
  (token, uom_id, onSuccessDelete) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });
      let response = await axios.delete(`${serverApi}/uom/${uom_id}`, {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        onSuccessDelete();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_delete_uom_ratio =
  (token, ratio_id, onSuccessDelete) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });
      let response = await axios.delete(`${serverApi}/uom-ratio/${ratio_id}`, {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        onSuccessDelete();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
